import React, { useEffect, useState } from 'react';
import type { CashSummary, UpsertClosurePayload } from '../../types/cash';

function toNum(v: string): number | undefined {
  const x = Number(v.replace(',', '.'));
  return Number.isFinite(x) ? x : undefined;
}

function eur(v: number | null | undefined) {
  if (v == null) return '—';
  return Number(v).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
}

export function CashClosurePanel(props: {
  date: string;
  posId?: string;
  closure: CashSummary['closure'];
  onSave: (p: UpsertClosurePayload) => Promise<void>;
}) {
  const [openingFloat, setOpeningFloat] = useState('');
  const [cashCounted, setCashCounted] = useState('');
  const [bundlesTotal, setBundlesTotal] = useState('');
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setOpeningFloat(props.closure?.openingFloat?.toString() ?? '');
    setCashCounted(props.closure?.cashCounted?.toString() ?? '');
    setBundlesTotal(props.closure?.bundlesTotal?.toString() ?? '');
    setNote(props.closure?.note ?? '');
  }, [props.closure]);

  async function save() {
    setSaving(true);
    try {
      await props.onSave({
        closureDate: `${props.date}T23:59:00.000Z`,
        posId: props.posId,
        openingFloat: toNum(openingFloat),
        cashCounted: toNum(cashCounted),
        bundlesTotal: toNum(bundlesTotal),
        note: note || undefined,
      });
    } finally {
      setSaving(false);
    }
  }

  return (
    <>
      <div className="mb-3">
        <label className="form-label">Fondo cassa</label>
        <input
          className="form-control"
          value={openingFloat}
          onChange={(e) => setOpeningFloat(e.target.value)}
          placeholder="es. 150"
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Contante trovato in cassa</label>
        <input
          className="form-control"
          value={cashCounted}
          onChange={(e) => setCashCounted(e.target.value)}
          placeholder="es. 680"
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Totale mazzette</label>
        <input
          className="form-control"
          value={bundlesTotal}
          onChange={(e) => setBundlesTotal(e.target.value)}
          placeholder="es. 600"
        />
        <div className="form-text">Se non lo avete, lasciatelo vuoto.</div>
      </div>

      <div className="mb-3">
        <label className="form-label">Note</label>
        <textarea className="form-control" value={note} onChange={(e) => setNote(e.target.value)} rows={3} />
      </div>

      <button className="btn btn-primary w-100" onClick={save} disabled={saving}>
        {saving ? 'Salvataggio…' : 'Salva chiusura'}
      </button>

      <hr className="my-3" />

      {props.closure ? (
        <div className="small">
          <div className="d-flex justify-content-between">
            <span className="text-muted">Atteso</span>
            <span className="fw-semibold">{eur(props.closure.expectedCash)}</span>
          </div>
          <div className="d-flex justify-content-between">
            <span className="text-muted">Differenza</span>
            <span className="fw-semibold">{eur(props.closure.cashDifference)}</span>
          </div>
          <div className="d-flex justify-content-between">
            <span className="text-muted">Origine</span>
            <span className="fw-semibold">{props.closure.source}</span>
          </div>
        </div>
      ) : (
        <div className="text-muted">Nessuna chiusura salvata per questa data.</div>
      )}
    </>
  );
}